var _style, _path, _path2, _path3, _polygon, _rect, _path4, _polygon2, _polygon3, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAtlassian(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 222.5",
    style: {
      enableBackground: "new 0 0 200 222.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#2681FF;}\n\t.st2{fill:#0052CC;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Atlassian-vertical-blue-rgb") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Blue"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 91.0186,
    y1: 126.053,
    x2: 43.8446,
    y2: 44.345,
    gradientTransform: "matrix(1 0 0 -1 0 224.0003)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0052CC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923,
    style: {
      stopColor: "#2684FF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.5,84.2c-2.7-2.9-7-2.7-8.8,1L13,174.5c-1.3,2.6-0.3,5.8,2.4,7.2c0.7,0.4,1.6,0.6,2.4,0.6H80 c2,0,3.9-1.1,4.8-3C98.2,151.5,90.1,109.3,66.5,84.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.3,2.9c-25,39.6-23.3,83.5-6.9,116.4l30,60c0.9,1.8,2.8,3,4.8,3h62.2c3,0,5.3-2.4,5.3-5.3 c0-0.8-0.2-1.6-0.6-2.4c0,0-83.7-167.5-85.8-171.7C106.5-0.9,101.7-1,99.3,2.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M91.2,204.6c0,3.6,1.7,6.4,8.2,7.7c3.9,0.8,4.7,1.4,4.7,2.7c0,1.3-0.8,2.1-3.6,2.1c-3.3-0.1-6.6-0.9-9.4-2.6 v5.9c2.9,1.5,6.1,2.2,9.4,2c6.8,0,9.5-3,9.5-7.6 M110,214.9c0-4.3-2.3-6.3-8.6-7.6c-3.5-0.8-4.4-1.6-4.4-2.7c0-1.4,1.3-2,3.6-2 c2.9,0.1,5.7,0.8,8.2,2v-5.6c-2.5-1.1-5.3-1.7-8-1.7c-6.3,0-9.6,2.7-9.6,7.2"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "178.8,197.8 178.8,222.1 184,222.1 184,203.5 186.2,208.5 193.5,222.1 200,222.1 200,197.8  194.8,197.8 194.8,213.5 192.9,208.9 187,197.8  "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 140.1,
    y: 197.8,
    className: "st2",
    width: 5.7,
    height: 24.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M133.6,214.9c0-4.3-2.3-6.3-8.6-7.6c-3.5-0.8-4.4-1.6-4.4-2.7c0-1.4,1.3-2,3.6-2c2.9,0.1,5.7,0.8,8.2,2v-5.6 c-2.5-1.1-5.3-1.7-8-1.7c-6.3,0-9.6,2.7-9.6,7.2c0,3.6,1.7,6.4,8.2,7.7c3.9,0.8,4.7,1.4,4.7,2.7c0,1.3-0.8,2.1-3.6,2.1 c-3.3-0.1-6.6-0.9-9.4-2.6v5.9c2.9,1.5,6.1,2.2,9.4,2C130.9,222.5,133.6,219.4,133.6,214.9"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "47.2,197.8 47.2,222.1 58.9,222.1 60.7,216.8 52.9,216.8 52.9,197.8  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "24.2,197.8 24.2,203 30.5,203 30.5,222.1 36.2,222.1 36.2,203 43,203 43,197.8  "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M16,197.8H8.5L0,222.1h6.5l1.2-4.1c3,0.9,6.1,0.9,9.1,0l1.2,4.1h6.5L16,197.8z M12.2,213.6 c-1.1,0-2.1-0.2-3.1-0.4l3.1-10.6l3.1,10.6C14.3,213.5,13.3,213.6,12.2,213.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M79,197.8h-7.5L63,222.1h6.5l1.2-4.1c3,0.9,6.1,0.9,9.1,0l1.2,4.1h6.5L79,197.8z M75.2,213.6 c-1.1,0-2.1-0.2-3.1-0.4l3.1-10.6l3.1,10.6C77.3,213.5,76.3,213.6,75.2,213.6L75.2,213.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M166.2,197.8h-7.5l-8.5,24.3h6.5l1.2-4.1c3,0.9,6.1,0.9,9.1,0l1.2,4.1h6.5L166.2,197.8z M162.5,213.6 c-1.1,0-2.1-0.2-3.1-0.4l3.1-10.6l3.1,10.6C164.6,213.5,163.5,213.6,162.5,213.6L162.5,213.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtlassian);
export default __webpack_public_path__ + "static/media/atlassian.5eb296863dcd0de2eb3c9e5b515a1a64.svg";
export { ForwardRef as ReactComponent };